/*
 *  Copyright (c) 2018-present, Evgeny Nadymov
 *
 * This source code is licensed under the GPL v.3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon';

export default createSvgIcon(
    <g strokeWidth='1' fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round'>
        <g transform='translate(-3.000000, 0.000000)'>
            <circle strokeWidth='1.2' cx='10' cy='7' r='6' />
            <line x1='10' y1='3.5' x2='10' y2='7' strokeWidth='1.3' />
            <line x1='12' y1='9' x2='10' y2='7' strokeWidth='1.3' />
        </g>
    </g>,
    'Pending'
);
